import { render, staticRenderFns } from "./ShippingReturns.vue?vue&type=template&id=ba2de022&"
import script from "./ShippingReturns.vue?vue&type=script&lang=js&"
export * from "./ShippingReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports